import {
  BillingModel,
  BillingPlan,
  RecurringInterval,
  SubscriptionStatus,
  MobileStore,
} from "../types";

import { FEATURES } from "./features";
import { billingConfigSchema } from "./schema";

import type { BillingConfig } from "./schema";

export const config = billingConfigSchema.parse({
  plans: [
    {
      id: BillingPlan.FREE,
      name: "plan.free.name",
      description: "plan.free.description",
      badge: null,
      features: Object.values(FEATURES[BillingPlan.FREE]),
      variants: [
        {
          id: "free-monthly",
          cost: 4900,
          currency: "GBP",
          interval: RecurringInterval.MONTH,
          model: BillingModel.RECURRING,
          trialDays: 14,
        },
        {
          id: "free-yearly",
          cost: 49000,
          currency: "GBP",
          interval: RecurringInterval.YEAR,
          model: BillingModel.RECURRING,
          trialDays: 14,
        },
      ],
    },
    {
      id: BillingPlan.PREMIUM,
      name: "plan.premium.name",
      description: "plan.premium.description",
      badge: "plan.premium.badge",
      features: Object.values(FEATURES[BillingPlan.PREMIUM]),
      variants: [
        {
          id: "price_1SnNneF6GIkBZmgVdX4GP7O8",
          cost: 9500,
          currency: "GBP",
          interval: RecurringInterval.MONTH,
          model: BillingModel.RECURRING,
          trialDays: 14,
        },
        {
          id: "price_1SnNoVF6GIkBZmgViiuMqIv0",
          cost: 95000,
          currency: "GBP",
          interval: RecurringInterval.YEAR,
          model: BillingModel.RECURRING,
          trialDays: 14,
        },

        /* MOBILE */
        {
          id: "core_premium_recurring_month_flat",
          cost: 9500,
          currency: "GBP",
          interval: RecurringInterval.MONTH,
          model: BillingModel.RECURRING,
          trialDays: 14,
          hidden: true,
        },
        {
          id: "core_premium_recurring_year_flat",
          cost: 95000,
          currency: "GBP",
          interval: RecurringInterval.YEAR,
          model: BillingModel.RECURRING,
          trialDays: 14,
          hidden: true,
        },
      ],
    },
    {
      id: BillingPlan.ENTERPRISE,
      name: "plan.enterprise.name",
      description: "plan.enterprise.description",
      badge: null,
      features: Object.values(FEATURES[BillingPlan.ENTERPRISE]),
      variants: [
        {
          id: "enterprise-monthly",
          cost: 17900,
          currency: "GBP",
          model: BillingModel.RECURRING,
          interval: RecurringInterval.MONTH,
          trialDays: 14,
        },
        {
          id: "enterprise-yearly",
          cost: 179000,
          currency: "GBP",
          model: BillingModel.RECURRING,
          interval: RecurringInterval.YEAR,
          trialDays: 14,
        },
      ],
    },
  ],
  discounts: [],
}) satisfies BillingConfig;

export * from "./features";
export * from "./organization";
export * from "./schema";

export const ACTIVE_SUBSCRIPTION_STATUSES = [
  SubscriptionStatus.ACTIVE,
  SubscriptionStatus.TRIALING,
];

export const MOBILE_STORE_LINKS = {
  [MobileStore.APP_STORE]: "https://apps.apple.com/account/subscriptions",
  [MobileStore.PLAY_STORE]:
    "https://play.google.com/store/account/subscriptions",
} as const satisfies Record<MobileStore, string>;
